export default "__VITE_ASSET__BThgzUaD__"